export enum ICurrencyTabs {
  addNewCurrency = "1",
  currencyTable = "2",
}
